export const validationGroup = {
  companyDetails: ['accountName', 'officialName', 'tradeName', 'prevTradeName', 'orgType', 'regNumber'],
  contactPerson: [
    'salutation',
    'firstName',
    'lastName',
    'email',
    'phone',
    'mobile',
    'docPrefDeliveryMethod',
    'docPrefLanguage',
    'positionHeld',
    'dateOfBirth',
  ],
  addressDetails: ['addressLine1', 'addressLine2', 'addressLine3', 'addressLine4', 'postCode', 'county', 'country'],
};
